module.exports = __webpack_public_path__ + "images/category_lp/alcohol/new/store_images/4_b40ec1ad6076e1e74b6f8d32809999d4.png";